import { datadogRum } from '@datadog/browser-rum';
import { ITotem } from '../interfaces/totem.interface';

export const setGlobalPropertiesDatadog = ({ id, branchCode, name, country }: ITotem) => {
	datadogRum.setGlobalContextProperty('branchId', id);
	datadogRum.setGlobalContextProperty('branchCode', branchCode);
	datadogRum.setGlobalContextProperty('branchName', name);
	datadogRum.setGlobalContextProperty('branchCountry', country);
};
